import { render, staticRenderFns } from "./AccordionTabList.vue?vue&type=template&id=6c03750c&scoped=true"
import script from "./AccordionTabList.vue?vue&type=script&lang=js"
export * from "./AccordionTabList.vue?vue&type=script&lang=js"
import style0 from "./AccordionTabList.vue?vue&type=style&index=0&id=6c03750c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c03750c",
  null
  
)

export default component.exports